// Generated by `npm --workspace @pleio/icons run generate`, do not edit.
import { type ForwardedRef, forwardRef } from 'react'

import type { IconProps } from '../types'

export const ColumnShrinkIcon = forwardRef<SVGSVGElement, IconProps>((
    { title, titleId, ...props }: IconProps,
    ref: ForwardedRef<SVGSVGElement>,
) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={14} viewBox="0 0 24 14" display="block" focusable="false" role="img" aria-hidden="true" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g id="column-shrink" fill="none" fillRule="evenodd" stroke="none" strokeWidth={1}><g id="Group" transform="translate(.045)"><path id="bg" fill="#FFF" d="M7.955 1h8v12h-8z" /><path id="Combined-Shape" fill="currentColor" d="M16.955 0v14h-10V0zm-2 2h-6v10h6zm8 9V3l-5 4zm-22 0V3l5 4z" /></g></g></svg>
))
